import React from 'react';
import classes from './Button.module.css'

const Button = props => {
    return (
        <button
         className={classes.myButton}
         onClick={props.onButtonClick}
        >{props.children}
        </button>
    );
};
export default Button
